import { AddIcon, Button, makeStyles, MenuItem, TextField, TextFieldProps } from '@freighthub/silhouette-core'
import { FC } from 'react'

import { IContact } from '../../domain/ShipmentInterface'

export type ContactSelectProps = TextFieldProps & {
  contacts: IContact[]
  newContactLabel: string
}

const useStyles = makeStyles((theme) => ({
  addButton: {
    textTransform: 'uppercase',
    fontSize: theme.typography.body1.fontSize,
  },
}))

const getMenuItemText = (contact: IContact) => {
  if (contact.companyName && contact.contactPerson) {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return `${contact.companyName} - ${contact.contactPerson} - ${contact.email}`
  }
  if (contact.companyName) {
    return contact.companyName
  }
  if (contact.contactPerson) {
    return contact.contactPerson
  }
  return contact.email
}

export const ContactSelect: FC<ContactSelectProps> = ({ contacts, newContactLabel, ...restProps }) => {
  const classes = useStyles()
  return (
    <TextField {...restProps} select>
      {contacts.map((contactItem: IContact) => (
        <MenuItem key={contactItem._id} value={contactItem._id}>
          {getMenuItemText(contactItem)}
        </MenuItem>
      ))}

      <MenuItem key="add" value="add">
        <Button className={classes.addButton} startIcon={<AddIcon />} fullWidth>
          {newContactLabel}
        </Button>
      </MenuItem>
    </TextField>
  )
}
